import { render } from "./ClinicalLab.vue?vue&type=template&id=6be0c6e0"
import script from "./ClinicalLab.vue?vue&type=script&lang=js"
export * from "./ClinicalLab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__